import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { DeviceLockService } from '@evorait/pace-core';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { of } from 'rxjs';

export const deviceLockGuard: CanActivateFn = () => {
    if (environment.operateInMockMode) {
        return of(true);
    }
    const deviceLockService = inject(DeviceLockService);
    return deviceLockService.lockState$.pipe(map((lockState) => lockState.ownedByMe));
};
